import dayjs from "dayjs";

export default function formatarData(data) {
    let dt = data;
    if (!!data && dayjs().isValid(data))
        dt = dayjs(data);

    return {
        DIA: dt.format("DD"),
        MES: dt.format("MM"),
        ANO: dt.format("YYYY"),
        MESANO: dt.format("MM/YYYY"),
        DATA: dt.format("DD/MM/YYYY"),
        DATAHORA: dt.format("DD/MM/YYYY HH:mm"),
        DATAHORASEGUNDOS: dt.format("DD/MM/YYYY HH:mm:ss"),
    };
}